/*
  redirect `/pages/search-results-page?q=<query>` to `/search?q=<query>`
  or `ar/pages/search-results-page?q=<query>` to `/ar/search?q=<query>`
*/

(function() {
  const currentPath = window.location.pathname;
  const searchParams = window.location.search;

  // Check if current path matches the search results page pattern
  const isSearchResultsPage = currentPath.includes('/pages/search-results-page');

  if (isSearchResultsPage && searchParams) {
    // Determine if we're on an Arabic locale page
    const isArabic = currentPath.startsWith('/ar/');

    // Construct the new search URL
    const newPath = isArabic ? '/ar/search' : '/search';
    const newUrl = newPath + searchParams;

    // Perform the redirect
    window.location.replace(newUrl);
  }
})();